import React from 'react'
import { useHistory } from 'react-router-dom'

import { MenuItem } from 'common/components'
import { ROUTE_PATHS } from 'common/routePaths'

import IchraDecisionToolsLogo from 'assets/images/IchraDecisionToolLogo'
import PeoplekeepLogo from 'assets/images/PeoplekeepLogo'

const { PROSPECTS_PATH } = ROUTE_PATHS

interface Props {}

const Logo: React.FC<Props> = () => {
  const history = useHistory()
  return (
    <MenuItem key={0} onClick={() => history.push(PROSPECTS_PATH)} className="pl-64 no_hover_styles">
      <div className="flex flex__align_center">
        <div className="mv-8 flex">
          <PeoplekeepLogo />
        </div>
        <div className="vertical_line mv-8">{` `}</div>
        <div className="flex">
          <IchraDecisionToolsLogo />
        </div>
      </div>
    </MenuItem>
  )
}

export default Logo
